module.exports = __webpack_public_path__ + "static/media/Roboto-BlackItalic.c470ca2b.ttf";